import type {
  TrackPageOptions,
  TrackTMSPageDatalayer,
} from "@edreamsodigeo/frontend-tracking-agent";
import { thirdPartyTracking } from "@edreamsodigeo/frontend-tracking-agent";

export const createCustomDimensionsRepository =
  thirdPartyTracking.createCustomDimensionsRepository;
export const createDatalayerTrackingClient =
  thirdPartyTracking.createDatalayerTrackingClient;
export const createECommerceTrackingClient =
  thirdPartyTracking.createECommerceTrackingClient;
export const createFirebaseAdapter = thirdPartyTracking.createFirebaseAdapter;
export const createThirdPartyTrackingAgent =
  thirdPartyTracking.createThirdPartyTrackingAgent;
export const createTrackingParamsRepository =
  thirdPartyTracking.createTrackingParamsRepository;

export interface TMSFetchOptions {
  skipFetch: boolean;
}

export interface PageTracker {
  trackGAPage: (page: string, options?: TrackPageOptions) => void;
  trackTMSPage: (
    dataLayer: TrackTMSPageDatalayer,
    fetchOptions?: TMSFetchOptions,
  ) => void;
}

const noop = () => {};

export const pageTracker: PageTracker = {
  trackGAPage: (...args) => {
    thirdPartyTracking.trackGAPage(...args).catch(noop);
  },
  trackTMSPage: (...args) => {
    thirdPartyTracking.trackTMSPage(...args).catch(noop);
  },
};

export type {
  CustomDimensions,
  CustomDimensionsOrParams,
  CustomParams,
  ECommerce4Transaction,
  SetCustomDimensionOrParam,
  ThirdPartyTrackingAgentArgs,
} from "@edreamsodigeo/frontend-tracking-agent";
export { createDataMeshTrackingClient } from "@edreamsodigeo/frontend-tracking-agent";
